/* global window */
export const DEFAULT_DATA_GRID_LIMIT = 10;
export const DATA_GRID_LIMIT_LOCAL_SESSION_KEY = 'items_shown_per_page';
export const DEFAULT_OFFSET = 0;
export const DEFAULT_COUNT_API_LIMIT = 100;
export const HIDDEN_ID_CELL = {
    field: 'id',
    headerName: 'ID',
    sortable: false,
    hide: true // For DataGrid component use columnVisibilityModel prop to hide a column
};
export const HIDDEN_CREATED_AT_CELL = {
    field: 'created_at',
    headerName: 'Created At',
    sortable: true,
    hide: true // For DataGrid component use columnVisibilityModel prop to hide a column
};
export const DEFAULT_PAGED_SORTED_QUERY_PARAMS = {
    limit: '25',
    offset: '0'
};
export function getDefaultGridPageSize() {
    const storedLimitValue = parseInt(window.localStorage.getItem(DATA_GRID_LIMIT_LOCAL_SESSION_KEY) || '');
    if (!isNaN(storedLimitValue)) {
        return storedLimitValue;
    }
    return DEFAULT_DATA_GRID_LIMIT;
}
export function getChipCountText(count) {
    return count < DEFAULT_COUNT_API_LIMIT ? count : `${DEFAULT_COUNT_API_LIMIT - 1}+`;
}
